import { RouteAccess } from '../AppConstants';
import DevicesIcon from '@mui/icons-material/Devices';
const SideNavOptions = [
  { path: '/devices', title: 'Devices', icon: () => <DevicesIcon />, access: RouteAccess.Administrator },
];

export default SideNavOptions;